export const GET_FOOTER_PARTNERS = "GET_FOOTER_PARTNERS";
export const GET_FOOTER_PARTNERS_PENDING = "GET_FOOTER_PARTNERS_PENDING";
export const GET_FOOTER_PARTNERS_REJECTED = "GET_FOOTER_PARTNERS_REJECTED";
export const GET_FOOTER_PARTNERS_FULFILLED = "GET_FOOTER_PARTNERS_FULFILLED";
